import { Modal, Box } from "@mui/material";
import { addScript } from "./rptemplate";
import styles from "../ProductsRPDesigner.module.scss"

function ResponsePageModal({ openPreview, setOpenPreview, selectedDevice, previewCode}) {

    return (
        <Modal
            open={openPreview}
            onClose={(e) => setOpenPreview(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box 
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: selectedDevice,
                height: 'min(640px, 90%)'
            }}>
                {openPreview && 
                    <div 
                        id="previewDiv" 
                        className={styles["smartphone"]}
                        dangerouslySetInnerHTML={{__html: previewCode}}
                    >
                        {addScript()}
                    </div>}
            </Box>
        </Modal>                                              
    )
}

export default ResponsePageModal;